exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2kihM{font-size:24px;font-size:1.5rem;font-weight:300;margin:0;margin-bottom:24px;margin-bottom:1.5rem;text-align:center}._3z8Zx{font-size:20px;font-size:1.25rem;font-weight:300;margin:0;margin-bottom:16px;margin-bottom:1rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}._3z8Zx i{margin-right:16px;margin-right:1rem;color:#ccc}._2J5mH{text-align:center}", ""]);

// exports
exports.locals = {
	"root": "Q5puq",
	"main_item": "_2kihM",
	"item": "_3z8Zx",
	"h2": "_2J5mH"
};